import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface AlertDialogProps {
  open: boolean;
  handleClose: (answer: string) => () => void;
}

export function AlertDialog(props: AlertDialogProps) {
  const { open, handleClose } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose('close')}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">레이어 수정</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          에디트(Edit) 모드 상태에서는 레이어를 클릭하면 해당 레이어 경계를
          변경하거나 지울수 있습니다. 이동을 원하시면 Lock 버튼을 눌러
          저장하시고 다시 클릭해 주세요
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose('edit')}>수정</Button>
        <Button onClick={handleClose('delete')}>지우기</Button>
        <Button onClick={handleClose('close')} autoFocus>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  handleClose: (answer: string) => () => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  handleClose,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={handleClose('close')}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose('confirm')}>확인</Button>
        <Button onClick={handleClose('cancel')}>취소</Button>
      </DialogActions>
    </Dialog>
  );
}
